import PropTypes from 'prop-types'
import {StyledTabPanelRoot, StyledTabPanelTitle, StyledTabPanelContent} from './TabsComponentStyles'

const TabPanel = ({children, title, value, index, ...other}) => {
  const isActive = value === index
  return (
    <StyledTabPanelRoot
      role='tabpanel'
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      tabIndex={isActive ? 0 : -1}
      isActive={isActive}
      {...other}
    >
      <StyledTabPanelTitle variant='h6' aria-label={title}>
        {title}
      </StyledTabPanelTitle>
      {isActive && <StyledTabPanelContent>{children}</StyledTabPanelContent>}
    </StyledTabPanelRoot>
  )
}

TabPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
}

export default TabPanel
